import { render, staticRenderFns } from "./AgDateText.vue?vue&type=template&id=5a922600&"
import script from "./AgDateText.vue?vue&type=script&lang=js&"
export * from "./AgDateText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports